import { DELETE_WS, DELETE_WS_SUCCESS, DELETE_WS_ERROR} from './actionTypes';

export const deleteWorkstations = (user, ws, token, history) => {
    return {
        type: DELETE_WS,
        payload: { user, ws, token, history }
    }
}

export const deleteWorkstationsSuccess = (message) => {
    return {
        type: DELETE_WS_SUCCESS,
        payload: {message}
    }
}

export const deleteWorkstationsError = (ws) => {
    return {
        type: DELETE_WS_ERROR,
        payload: ws
    }
}
